'use client'

import type { MetricRowPayload } from '../svs-types'
import { KpiCard } from './KpiRenderer'

interface MetricRowRendererProps {
  payload: MetricRowPayload
}

export function MetricRowRenderer({ payload }: MetricRowRendererProps) {
  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
      {payload.data.metrics.map((metric, i) => (
        <div
          key={i}
          className="rounded-lg border border-border bg-card p-3"
        >
          <KpiCard metric={metric} useLabel />
        </div>
      ))}
    </div>
  )
}
